var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-9b09342188fefb54b61fd0b9946ff0fc.svg#icon-googleplay-eb32c';
                    var viewUrl = 'svg-sprite-9b09342188fefb54b61fd0b9946ff0fc.svg#view-icon-googleplay-eb32c';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 135 40',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };